import { pipe } from 'fp-ts/function';
import * as RA from 'fp-ts/ReadonlyArray';
export * from 'fp-ts-std/ReadonlyArray';
export * from 'fp-ts/ReadonlyArray';
export var hasSizeOf = function (size) { return function (as) { return RA.size(as) === size; }; };
export var splitAtV = function (as) { return function (n) {
    return pipe(as, RA.splitAt(n));
}; };
